import { ReactNode, useState } from 'react'
import { Button, Box, Switch, useTheme, useMediaQuery, Typography } from '@mui/material'

import useStyles from './styles'
import { IAction } from '.'
import { HelperWrapper } from '../helper-wrapper'
import { ChevronDownIcon } from 'src/assets/icons/v2/ChevronDownIcon'
import { ChevronUpIcon } from 'src/assets/icons/v2/ChevronUpIcon'

interface IAssociationsListItemProps {
  id: string
  actions: IAction[]
  actionsTitle?: ReactNode
}

const AssociationsItemActions = ({
  id,
  actions = [],
  actionsTitle,
}: IAssociationsListItemProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const theme = useTheme()
  const classes = useStyles({})

  const isMobile = useMediaQuery(theme.breakpoints.down('tablet_s'))

  const handleOpen = () => {
    setIsOpen((prev) => !prev)
  }

  return (
    <>
      <div className={classes.actionsWrapper}>
        <div style={{ marginBottom: isOpen ? '10px' : 0 }} className={classes.actionsButtonWrapper}>
          <Typography
            onClick={handleOpen}
            variant="body2"
            sx={{ fontSize: '14px', color: theme.palette.custom.grey2, cursor: 'pointer' }}
          >
            <HelperWrapper t="show-additional-options-lable" usePortal isColorInherited />
          </Typography>
          <Button
            size="small"
            sx={{
              minWidth: 0,
              width: 35,
              height: 35,
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onClick={handleOpen}
          >
            {isOpen ? (
              <ChevronUpIcon size={28} color={theme.palette.custom.grey2} />
            ) : (
              <ChevronDownIcon size={28} color={theme.palette.custom.grey2} />
            )}
          </Button>
        </div>

        {isOpen && (
          <>
            {actionsTitle && <div className={classes.actionsTitle}>{actionsTitle}</div>}
            {actions.map(({ isShow, lable, handleSwitch }, index) => (
              <div key={index} className={classes.switchWrapper}>
                <Box
                  sx={{
                    ml: 0,
                    mr: 0,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: isMobile ? '100%' : '280px',
                  }}
                >
                  <Typography variant="body2" className={classes.selectionSubtext}>
                    {lable}
                  </Typography>
                  <Switch checked={isShow(id)} onChange={() => handleSwitch(id)} size="small" />
                </Box>
                {/* <FormControlLabel
                  sx={{
                    ml: 0,
                    mr: 0,
                    justifyContent: 'space-between',
                    width: isMobile ? '100%' : '280px',
                    '& .MuiFormControlLabel-label': {
                      pointerEvents: 'none', // Disable pointer events for the label
                    },
                  }}
                  checked={isShow(id)}
                  onChange={() => handleSwitch(id)}
                  control={<Switch size="small" />}
                  label={lable}
                  labelPlacement="start"
                  classes={{
                    label: classes.selectionSubtext,
                  }}
                /> */}
              </div>
            ))}
          </>
        )}
      </div>
    </>
  )
}

export { AssociationsItemActions }
